import * as React from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { request, resourceLink } from "../../services/cpln";
import { Loader } from "../../components/layout/loader";
import { DetailContext } from "../../components/detail/detailContext";
import { Helmet } from "react-helmet";
import { IS_DEPLOYMENT_ENV_TEST } from "../../envVariables";
import { VolumeSetMobx, VolumeSetModel } from "../../mst/kinds/volumeset";
import { VolumeSetDetail } from "./detail";
import { getDraftVolumeSet, VolumeSetDraftMobx } from "../../mst/stores/volumeset.draft";
import { NGFormData } from "../../mobxStores/ngFormData";
import { NGFormContext } from "../../reactContexts/ngFormContext";
import { captureExc } from "../../errorBoundary";

type RouteParams = "volumeset";
const VolumeSetDetailRouteRaw: React.FC = () => {
  const formDataRef = React.useRef(new NGFormData());
  const { volumeset: volumeSetName } = useParams<RouteParams>();
  const [volumeSet, setVolumeSet] = React.useState<VolumeSetMobx>(null as any);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isIncorrect, setIsIncorrect] = React.useState(false);
  const draftRef = React.useRef<VolumeSetDraftMobx>(null as any);

  React.useEffect(() => {
    fetchItem();
  }, [volumeSetName]);

  async function fetchItem() {
    try {
      setIsLoading(true);
      const { data: volumeSetRes } = await request({ url: resourceLink("volumeset", volumeSetName) });
      const volumeSetInstance: VolumeSetMobx = VolumeSetModel.create(volumeSetRes);
      setVolumeSet(volumeSetInstance);
      draftRef.current = getDraftVolumeSet(volumeSetInstance);
      setIsLoading(false);
    } catch (e) {
      captureExc(e);
      setIsIncorrect(true);
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return <Loader fullScreen reason={"fetching volumeset to show detail"} />;
  }

  if (isIncorrect) {
    return <IncorrectItem kind={"volumeset"} canCreate={true} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {IS_DEPLOYMENT_ENV_TEST ? `TEST | ` : ""}
          {volumeSet.name} - Volume Set - From many clouds, one™
        </title>
      </Helmet>
      <NGFormContext.Provider value={formDataRef.current}>
        <DetailContext.Provider value={{ item: volumeSet, fetchItem }}>
          <VolumeSetDetail volumeSet={volumeSet} volumeSetDraft={draftRef.current} />
        </DetailContext.Provider>
      </NGFormContext.Provider>
    </>
  );
};

export const VolumeSetDetailRoute = observer(VolumeSetDetailRouteRaw);
